import {
  CheckCircle,
  ErrorOutline,
  HourglassEmpty,
  RemoveCircleOutline,
} from "@mui/icons-material"
import { Chip, type ChipProps } from "@mui/material"
import { Link } from "react-router-dom"

import { formatDateTime } from "../data-grid-utils"

import type { PurchaseReceiptOrderStatus } from "../../api"

type ChipLook = Pick<ChipProps, "label" | "color" | "icon" | "variant">

const SHORT_ORDER_ID_LENGTH = 8

const describeReceiptStatus = (
  receipt: PurchaseReceiptOrderStatus,
): ChipLook => {
  switch (receipt.status) {
    case "sent":
      return {
        label: `Receipt sent · ${formatDateTime(receipt.sentAt)}`,
        color: "success",
        icon: <CheckCircle />,
        variant: "outlined",
      }
    case "failed":
      return {
        label: "Receipt failed",
        color: "error",
        icon: <ErrorOutline />,
        variant: "outlined",
      }
    case "pending":
    case "sending":
      return {
        label: "Receipt pending",
        color: "warning",
        icon: <HourglassEmpty />,
        variant: "outlined",
      }
    case null:
      return {
        label: "No receipt",
        color: "default",
        icon: <RemoveCircleOutline />,
        variant: "outlined",
      }
  }
}

export function PurchaseReceiptStatusChip({
  receipt,
}: {
  receipt: PurchaseReceiptOrderStatus
}) {
  const look = describeReceiptStatus(receipt)
  const receiptOrderId = receipt.receiptOrderId

  if (!receiptOrderId) {
    return <Chip size="small" {...look} />
  }

  return (
    <Chip
      size="small"
      {...look}
      label={`${look.label} (on order ${receiptOrderId.slice(0, SHORT_ORDER_ID_LENGTH)})`}
      title={`The receipt for this FF Billing subscription belongs to order ${receiptOrderId}`}
      component={Link}
      to={`/orders/${receiptOrderId}`}
      clickable
    />
  )
}
